module.exports = __webpack_public_path__ + "img/juzhen.3ec33579.png";